import { ChathamLogo } from 'game/hud_components/ChathamLogo';
import { ButtonSoundCC } from 'game/hud_components/ButtonSoundCC';

const continueButtonDefault = {
  id: 'btn_continue',
  costume: 'btn_continue',
  buttongroup: 'bottomcenter',
  ariaLabel: 'continue',
  clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
};

const closeButtonDefault = {
  id: 'btn_close',
  costume: 'btn_close',
  buttongroup: 'topleft',
  ariaLabel: 'close',
  event: 'CLOSE',
  clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
};

export default {
  modal: { colour: '0x000000', alpha: 0.8 },
  buttons: [
    {
      id: 'chatham_logo',
      classname: ChathamLogo,
      type: 'component',
      buttongroup: 'bottomleft',
    },
    {
      id: 'btn_play',
      costume: 'btn_play',
      buttongroup: 'welcome',
      ariaLabel: 'start game',
      event: 'START_GAME',
      clickSFX: { sprite: 'sfx', id: 'chn_play' },
    },
    {
      id: 'btn_sound',
      costume: 'btn_sound_on',
      buttongroup: 'topright',
      ariaLabel: 'Sound',
      event: 'TOGGLE_SOUND',
      buttonClass: ButtonSoundCC,
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_pause',
      costume: 'btn_pause',
      buttongroup: 'topright',
      ariaLabel: 'pause game',
      event: 'PAUSE_GAME',
    },
    {
      id: 'btn_scores',
      costume: 'btn_scores',
      buttongroup: 'topleft',
      ariaLabel: 'player scores',
      event: 'PLAYERS_SCORES',
      // clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_close',
      costume: 'btn_close',
      buttongroup: 'topleft',
      ariaLabel: 'pause game',
      event: 'PLAYERS_SCORES',
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_home',
      costume: 'btn_home',
      buttongroup: 'topleft',
      ariaLabel: 'return home',
      event: 'RETURN_HOME',
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_howtoplay',
      costume: 'btn_howtoplay',
      buttongroup: 'bottomright',
      ariaLabel: 'how to play',
      event: 'SHOW_INSTRUCTIONS',
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_howtoplayback',
      costume: 'btn_back',
      buttongroup: 'topleft',
      ariaLabel: 'close how to play',
      event: 'CLOSE_INSTRUCTIONS',
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_htp_next',
      costume: 'btn_next',
      gelvo: 'next',
      buttongroup: 'htpcycle',
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_htp_previous',
      costume: 'btn_prev',
      gelvo: 'previous',
      buttongroup: 'htpcycle',
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_resume',
      costume: 'btn_play',
      buttongroup: 'center',
      ariaLabel: 'resume game',
      event: 'RESUME_GAME',
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    },
    {
      id: 'btn_replay',
      costume: 'btn_replay',
      buttongroup: 'bottomcenter',
      ariaLabel: 'replay game',
      event: 'REPLAY_GAME',
      clickSFX: { sprite: 'sfx', id: 'chn_play' },
    },
    { ...continueButtonDefault, id: 'btn_game_intro', event: 'CONTINUE_INTRO' },
    { ...continueButtonDefault, id: 'btn_game_outro', event: 'CONTINUE_OUTRO' },
    { ...closeButtonDefault, id: 'btn_close_modal', event: 'CLOSE_MODAL' },
    {
      ...closeButtonDefault,
      id: 'btn_close_scores_modal',
      event: 'CLOSE_SCORES_MODAL',
      clickSFX: false,
    },
  ],
  states: {
    EMPTY: {
      buttons: [],
    },
    WELCOME: {
      buttons: ['btn_play', 'btn_sound', 'btn_howtoplay', 'chatham_logo'],
    },
    HOW_TO_PLAY: {
      buttons: ['btn_howtoplayback'],
    },
    GAME_INTRO: {
      buttons: ['btn_game_intro'],
    },
    GAME_OUTRO: {
      buttons: ['btn_home', 'btn_game_outro'],
    },
    GAME: {
      buttons: ['btn_scores', 'btn_pause'],
    },
    SCORE_MODAL: {
      buttons: ['btn_close_scores_modal', 'btn_pause'],
    },
    RESULTS: {
      buttons: ['btn_home', 'btn_replay'],
    },
    PAUSE: {
      modal: true,
      buttons: ['btn_home', 'btn_sound', 'btn_resume', 'btn_howtoplay'],
    },
  },
  buttongroups: {
    welcome: {
      anchor_group: { x: 0.5, y: 0.5 },
      anchor_screen: { x: 0.5, y: 1 },
      align_buttons: 'center',
    },
    bottomcenter: {
      anchor_group: { x: 0.5, y: 0.5 },
      anchor_screen: { x: 0.5, y: 1 },
      align_buttons: 'center',
    },
    htpcycle: {
      anchor_group: { x: 0.5, y: 0.5 },
      anchor_screen: { x: 0.5, y: 0.48 },
      align_buttons: 'center',
      buttonPadding: 800,
    },
  },
};
